import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@storeblocks/surface-ng';
import { SurfaceModule } from '@storeblocks/surface-ng';
const _c0 = ["*"];
function AlertComponent_ng_container_0_p_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.heading);
  }
}
function AlertComponent_ng_container_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function AlertComponent_ng_container_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AlertComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, AlertComponent_ng_container_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const ngContent_r2 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ngContent_r2);
  }
}
function AlertComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "stb-surface", 3)(2, "div", 4)(3, "i", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 6);
    i0.ɵɵtemplate(6, AlertComponent_ng_container_0_p_6_Template, 2, 1, "p", 7)(7, AlertComponent_ng_container_0_div_7_Template, 2, 1, "div", 8)(8, AlertComponent_ng_container_0_div_8_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("variant", ctx_r0.surfaceVariant)("fluid", ctx_r0.width === "fluid" ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("alertBase ", ctx_r0.width, "");
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand);
    i0.ɵɵattribute("data-fluid", false)("data-variant", ctx_r0.type);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-stb-system-icon", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.typesToIconName(ctx_r0.type), " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", ctx_r0.role);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.heading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.text);
  }
}
function AlertComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function AlertComponent_div_3_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵtext(1, " error-filled ");
    i0.ɵɵelementEnd();
  }
}
function AlertComponent_div_3_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵtext(1, " warning-filled ");
    i0.ɵɵelementEnd();
  }
}
function AlertComponent_div_3_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵtext(1, " information-filled ");
    i0.ɵɵelementEnd();
  }
}
function AlertComponent_div_3_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵtext(1, " check-circle-filled ");
    i0.ɵɵelementEnd();
  }
}
function AlertComponent_div_3_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵtext(1, " information-filled ");
    i0.ɵɵelementEnd();
  }
}
function AlertComponent_div_3_strong_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.heading);
  }
}
function AlertComponent_div_3_p_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function AlertComponent_div_3_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function AlertComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 12);
    i0.ɵɵtemplate(2, AlertComponent_div_3_i_2_Template, 2, 0, "i", 13)(3, AlertComponent_div_3_i_3_Template, 2, 0, "i", 13)(4, AlertComponent_div_3_i_4_Template, 2, 0, "i", 13)(5, AlertComponent_div_3_i_5_Template, 2, 0, "i", 13)(6, AlertComponent_div_3_i_6_Template, 2, 0, "i", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵtemplate(8, AlertComponent_div_3_strong_8_Template, 2, 1, "strong", 1)(9, AlertComponent_div_3_p_9_Template, 2, 1, "p", 1)(10, AlertComponent_div_3_ng_container_10_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const ngContent_r2 = i0.ɵɵreference(2);
    i0.ɵɵclassMapInterpolate3("alert ", ctx_r0.width, " ", ctx_r0.type, " ", ctx_r0.margin ? "margin" : "", "");
    i0.ɵɵclassProp("rebrand", ctx_r0.rebrand);
    i0.ɵɵattribute("role", ctx_r0.role);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "error");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "warning");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "info");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.type === "info-subtle");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.heading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ngContent_r2);
  }
}
let AlertComponent = /*#__PURE__*/(() => {
  class AlertComponent {
    constructor() {
      this.type = 'info';
      this.heading = '';
      this.text = '';
      this.margin = undefined;
      this.width = 'default';
      this.role = null;
      this.surfaceVariant = 'background';
      this.rebrand = false;
    }
    get isRebrand() {
      return this.rebrand;
    }
    get isFluid() {
      return this.width === 'fluid' ? true : false;
    }
    ngOnInit() {
      if (this.rebrand && this.margin === undefined) {
        this.margin = false;
      }
    }
    // map type input to icon-names
    typesToIconName(type) {
      switch (type) {
        case 'error':
          return 'error-filled';
        case 'warning':
          return 'warning-filled';
        case 'success':
          return 'check-circle-filled';
        case 'info':
          return 'information-filled';
        case 'info-subtle':
          return 'information-filled';
      }
    }
  }
  AlertComponent.ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertComponent)();
  };
  AlertComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AlertComponent,
    selectors: [["stb-alert"]],
    hostVars: 4,
    hostBindings: function AlertComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("rebrand", ctx.isRebrand)("fluid", ctx.isFluid);
      }
    },
    inputs: {
      type: "type",
      heading: "heading",
      text: "text",
      margin: "margin",
      width: "width",
      role: "role",
      surfaceVariant: "surfaceVariant",
      rebrand: "rebrand"
    },
    ngContentSelectors: _c0,
    decls: 4,
    vars: 2,
    consts: [["ngContent", ""], [4, "ngIf"], [3, "class", "rebrand", 4, "ngIf"], [3, "variant", "fluid"], ["data-stb-alert", "true"], ["aria-hidden", "true", "translate", "no", 1, "systemIconBase", "icon", "icon-medium"], [1, "alertContainer"], ["class", "alertTitle font-body-demibold", 4, "ngIf"], ["class", "alertDescription font-body", 4, "ngIf"], [1, "alertTitle", "font-body-demibold"], [1, "alertDescription", "font-body"], [4, "ngTemplateOutlet"], [1, "alert-icon"], ["class", "icon-medium", "aria-hidden", "true", "translate", "no", 4, "ngIf"], [1, "alert-content"], ["aria-hidden", "true", "translate", "no", 1, "icon-medium"]],
    template: function AlertComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, AlertComponent_ng_container_0_Template, 9, 15, "ng-container", 1)(1, AlertComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, AlertComponent_div_3_Template, 11, 16, "div", 2);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.rebrand);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.rebrand);
      }
    },
    dependencies: [i1.NgIf, i1.NgTemplateOutlet, i2.SurfaceComponent],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}[_nghost-%COMP%]{display:flex}.fluid[_nghost-%COMP%]{flex:1 1 auto}.rebrand[_nghost-%COMP%]     p{text-wrap:pretty}.rebrand[_nghost-%COMP%]     .alertDescription p{font-family:Storebrand Text,sans-serif;font-size:1rem;font-weight:400;line-height:1.375rem}@media (min-width: 600px){.rebrand[_nghost-%COMP%]     .alertDescription p{font-size:1.125rem;line-height:1.625rem}}.rebrand.alertBase[data-stb-alert=true].small[_ngcontent-%COMP%]{max-width:288px}.rebrand.alertBase[data-stb-alert=true].default[_ngcontent-%COMP%]{max-width:430px}.rebrand.alertBase[data-stb-alert=true].large[_ngcontent-%COMP%]{max-width:560px}.rebrand.alertBase[data-stb-alert=true].fluid[_ngcontent-%COMP%]{width:100%;max-width:unset}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertTitle[_ngcontent-%COMP%]:first-letter{text-transform:capitalize}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]{--color-text: var(--p-color-text-on-info);--color-background: var(--p-color-surface-info);--color-icon: var(--p-color-icon-on-info);align-items:center;background:var(--color-background);border:none;border-radius:var(--p-corner-radius-small);box-sizing:border-box;display:inline-flex;max-width:560px;min-width:288px;padding:var(--p-spacing-24);position:relative}.rebrand.alertBase[data-stb-alert=true][data-variant=error][_ngcontent-%COMP%]{--color-text: var(--p-color-text-on-error);--color-background: var(--p-color-surface-error);--color-icon: var(--p-color-icon-on-error)}.rebrand.alertBase[data-stb-alert=true][data-variant=warning][_ngcontent-%COMP%]{--color-text: var(--p-color-text-on-warning);--color-background: var(--p-color-surface-warning);--color-icon: var(--p-color-icon-on-warning)}.rebrand.alertBase[data-stb-alert=true][data-variant=success][_ngcontent-%COMP%]{--color-text: var(--p-color-text-on-success);--color-background: var(--p-color-surface-success);--color-icon: var(--p-color-icon-on-success)}.rebrand.alertBase[data-stb-alert=true][data-variant=info-subtle][_ngcontent-%COMP%]{--color-text: var(--p-color-text-primary);--color-background: var(--p-color-surface-1);--color-icon: var(--p-color-icon-primary)}.rebrand.alertBase[data-stb-alert=true][data-fluid=true][_ngcontent-%COMP%]{max-width:100%;width:100%}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertTitle[_ngcontent-%COMP%], .rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertContainer[_ngcontent-%COMP%], .rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertDescription[_ngcontent-%COMP%], .rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .font-body[_ngcontent-%COMP%]{color:var(--color-text)}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertTitle[_ngcontent-%COMP%] + .alertDescription[_ngcontent-%COMP%]{margin-top:var(--p-spacing-rem-04)}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{align-self:flex-start;color:var(--color-icon);margin-right:var(--p-spacing-rem-16);margin-top:.07rem}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertDescription[_ngcontent-%COMP%]{text-wrap:pretty}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .alertContainer[_ngcontent-%COMP%]{align-self:flex-start;max-width:100%}@media (max-width: 600px){.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]{max-width:543px;padding:20px}.rebrand.alertBase[data-stb-alert=true][_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-right:var(--p-spacing-rem-12)}}.alert[_ngcontent-%COMP%]{display:flex;box-sizing:border-box;color:#191919;margin:0;font-size:16px;width:288px;font-family:Open Sans,sans-serif;font-weight:400;padding:17px 24px 13px 9px;gap:20px}.alert.margin[_ngcontent-%COMP%]{margin:16px 0}.alert.large[_ngcontent-%COMP%]{width:560px}.alert.fluid[_ngcontent-%COMP%]{width:100%}.alert.closed[_ngcontent-%COMP%]{opacity:0}.alert.error[_ngcontent-%COMP%]{background-color:#fee6db;border:3px dashed #e36a31}.alert.warning[_ngcontent-%COMP%]{background-color:#fdf6cf;border:3px dashed #c17b0b}.alert.success[_ngcontent-%COMP%]{background-color:#e8f3e1;border:3px dashed #4a966e}.alert.info[_ngcontent-%COMP%]{background-color:#cbf3f0;border:3px dashed #2a8eac}.alert.info-subtle[_ngcontent-%COMP%]{border:3px dashed #282828}.alert.error[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{color:#e36a31}.alert.warning[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{color:#c17b0b}.alert.info[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{color:#2a8eac}.alert.info-subtle[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{color:#282828}.alert.success[_ngcontent-%COMP%]   .alert-icon[_ngcontent-%COMP%]{color:#4a966e}.alert-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:block!important;width:24px}.alert-content[_ngcontent-%COMP%]{margin-right:auto}  .alert-content>strong{font-family:Open Sans,sans-serif;font-weight:600;margin-bottom:20px;margin-top:0;font-size:16px;display:inline-block;line-height:24px}  .alert-content>strong:first-letter{text-transform:capitalize}  .alert-content>p{margin:0;font-size:14px;line-height:24px}  .alert-content>p a{color:inherit;text-decoration:underline;background-color:transparent}"]
  });
  return AlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertModule = /*#__PURE__*/(() => {
  class AlertModule {}
  AlertModule.ɵfac = function AlertModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AlertModule)();
  };
  AlertModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AlertModule
  });
  AlertModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, SurfaceModule]
  });
  return AlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModule };
